<template>
  <div class="main" :style="mainBgStyle">
    <div class="mid">
      <!-- 左侧：后台配置系统名 -->
      <div class="left">
        <!-- <div class="system-name">
          {{ setting.bg_name || '微开分期系统' }}
        </div>
        <div class="chevrons">&gt;&gt;&gt;</div> -->
      </div>

      <!-- 右侧：登录 -->
      <div class="right">
        <div class="login">
          <img src="../assets/3.png" alt="" class="logo" />
          <div class="text3">多端全链路分期解决方案平台</div>
          <div class="title">快速登录</div>

          <div class="mcell">
            <div class="cell-value">
              <img src="../assets/imgs/1.png" class="ico" />
              <input
                v-model="form.username"
                type="text"
                placeholder="请输入账号"
              />
            </div>
          </div>

          <div class="mcell">
            <div class="cell-value">
              <img src="../assets/imgs/2.png" class="ico" />
              <input
                v-model="form.pwd"
                type="password"
                placeholder="请输入密码"
                @keyup.enter="onSubmit"
              />
            </div>
          </div>

          <div
            class="submit"
            :class="{ disabled: btnloading }"
            @click="onSubmit"
          >
            {{ btnloading ? '登录中...' : '登 录' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        username: '',
        pwd: ''
      },
      btnloading: false,
      setting: {
        bg: '',
        shop_bg: '',
        bg_name: ''
      }
    }
  },
  computed: {
    mainBgStyle() {
      const bg = this.setting.bg || require('../assets/imgs/bg.png')
      return {
        backgroundImage: `url(${bg})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center'
      }
    }
  },
  created() {
    this.$apiAll.setting.getConfig().then(res => {
      if (res && res.data) {
        Object.assign(this.setting, res.data)
      }
    })
  },
  methods: {
    async onSubmit() {
      if (this.btnloading) return

      if (!this.form.username) {
        this.$message.error('请输入账号')
        return
      }
      if (!this.form.pwd) {
        this.$message.error('请输入密码')
        return
      }

      this.btnloading = true
      try {
        const res = await this.$api.checkLogin(this.form)
        if (!res) return

        const data = res.data
        if (data.status == 1) {
          this.$message.error('管理员状态不可用')
          return
        }

        sessionStorage.setItem('admintoken', data.token)
        sessionStorage.setItem('shopId', data.shop_id)
        sessionStorage.setItem('logo', data.logo)

        const nav = await this.$api.getMyselfNav()
        const list = (nav && nav.data) || []
        const first = list.find(i => i.path)
        if (first) this.$router.push(first.path)
      } finally {
        this.btnloading = false
      }
    }
  }
}
</script>

<style scoped>
.main {
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.mid {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8vw;
  box-sizing: border-box;
}

/* 左侧标题区 */
.left {
  flex: 1;
  padding-top: 8vh;
  min-width: 0;
}

/* 与设计图一致：大号、加粗、深蓝 */
.system-name {
  font-size: 4rem;
  font-weight: bold;
  color: #1a365d;
  letter-spacing: 4px;
  line-height: 1.3;
  font-family: 'Microsoft YaHei', 'PingFang SC', Arial, sans-serif;
  word-break: break-all;
}

.chevrons {
  margin-top: 12px;
  font-size: 2.5rem;
  font-weight: bold;
  color: #0c73fe;
  letter-spacing: 6px;
}

/* 右侧登录框 */
.right {
  flex-shrink: 0;
  width: 32vw;
  min-width: 320px;
  max-width: 480px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.right .login {
  width: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  min-height: 52vh;
  padding: 40px 0 48px;
  box-shadow: 0 0 3px 1px #d0d0d0;
}

.logo {
  height: 3vw;
  min-height: 36px;
  max-height: 56px;
}

.text3 {
  font-size: 17px;
  color: #a0a6b2;
  padding: 6px 0;
  text-align: center;
}

.title {
  width: 80%;
  margin-left: 5%;
  color: #000;
  font-size: 22px;
  font-weight: 500;
  margin-top: 40px;
}

.ico {
  width: 18px;
  height: 18px;
  margin: 0 8px;
  flex-shrink: 0;
}

.mcell {
  width: 70%;
  background: #f4f8ff;
  padding: 4px 0;
  margin-top: 20px;
}

.mcell input {
  padding: 8px 0;
  border: none;
  outline: none;
  border-left: 1px solid #e6ebf3;
  margin-left: 5px;
  background: transparent;
  flex: 1;
  font-size: 15px;
}

.cell-value {
  display: flex;
  align-items: center;
  padding: 8px 10px;
}

.submit {
  width: 70%;
  margin-top: 30px;
  background: #0c73fe;
  color: #fff;
  height: 40px;
  border-radius: 8px;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
}

.submit.disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .mid {
    flex-direction: column;
    justify-content: center;
    padding: 24px;
  }

  .left {
    padding-top: 0;
    margin-bottom: 24px;
    text-align: center;
  }

  .system-name {
    font-size: 2rem;
  }

  .right {
    width: 100%;
    max-width: 400px;
    justify-content: center;
  }
}
</style>